import * as React from 'react';
import {
  APPLICATION_TASK_TAB_PAD_HEIGHT,
  COLLAPSED_COLUMN_WIDTH,
  COLLAPSED_ROW_HEIGHT,
  COLUMNS_START_PADDING,
  EXPANDED_COLUMN_WIDTH,
  HEADER_HEIGHT,
  SIDEBAR_WIDTH,
} from '../../layout';
import {
  useExpandedColumns,
  useGroupBy,
  useReleases,
  useRowHeights,
} from '../../state/context';

const Scroll = () => {
  const releases = useReleases();
  const [expandedColumns] = useExpandedColumns();
  const [groupBy] = useGroupBy();
  const rowHeights = useRowHeights();

  const width = React.useMemo(
    () => {
      const collapsedColumns = releases.length - expandedColumns.length;

      return (
        SIDEBAR_WIDTH +
        COLUMNS_START_PADDING +
        (expandedColumns.length * EXPANDED_COLUMN_WIDTH) +
        (collapsedColumns * COLLAPSED_COLUMN_WIDTH)
      );
    },
    [releases.length, expandedColumns.length]
  );

  const height = React.useMemo(
    () => {
      let value = (
        HEADER_HEIGHT +
        Object.values(rowHeights).reduce((acc, curr) => acc + curr, 0)
      );

      value += APPLICATION_TASK_TAB_PAD_HEIGHT;

      return value;
    },
    [rowHeights, groupBy]
  );

  return (
    <div
      className="bg-transparent transition-size"
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
    />
  );
};

export default Scroll;
